import { useEffect, useRef } from "react";

/**
 * Desloca o elemento no eixo Y conforme ele atravessa a viewport.
 * `speed` positivo sobe mais devagar que a página; negativo, mais rápido.
 */
export default function useParallax(speed = 0.12) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let ticking = false;
    let visible = false;

    const update = () => {
      const rect = el.getBoundingClientRect();
      // -1 (entrando por baixo) → 1 (saindo por cima)
      const center = rect.top + rect.height / 2;
      const offset = (center - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = `translate3d(0, ${offset * speed * 100}px, 0)`;
      ticking = false;
    };

    const onScroll = () => {
      if (ticking || !visible) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        visible = entry.isIntersecting;
        if (visible) update();
      },
      { rootMargin: "120px 0px" }
    );
    observer.observe(el);

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, [speed]);

  return ref;
}
